import { GeoJsonLayer } from '@deck.gl/layers';

export const filterByProductionYear = (wfsLayers, productionYearRange, setWfsLayers) => {
    const mjernaMjestaLayer = wfsLayers.find(layer => layer.id === 'mjerna_mjesta-layer');

    if (mjernaMjestaLayer) {
        const filteredFeatures = mjernaMjestaLayer.props.data.features.filter(feature => {
            const productionYear = feature.properties.godina_proizvodnje_brojila;
            return productionYear >= productionYearRange[0] && productionYear <= productionYearRange[1];
        });

        const filteredLayer = new GeoJsonLayer({
            id: 'filtered-by-production-year-mjerna-mjesta-layer',
            data: {
                type: "FeatureCollection",
                features: filteredFeatures
            },
            pickable: true,
            getFillColor: [255, 255, 0, 255],
            getLineColor: [255, 255, 0, 255], 
            getLineWidth: 15,
            lineWidthScale: 2,
            lineWidthMinPixels: 2,
            pointRadiusMinPixels: 5,
        });

        setWfsLayers(prevLayers => [
            ...prevLayers.filter(layer => layer.id !== 'filtered-by-production-year-mjerna-mjesta-layer'),
            filteredLayer
        ]);
    }
};

export const filterByControlDate = (wfsLayers, verificationYearRange, setWfsLayers) => {
    const mjernaMjestaLayer = wfsLayers.find(layer => layer.id === 'mjerna_mjesta-layer');

    if (mjernaMjestaLayer) {
        const filteredFeatures = mjernaMjestaLayer.props.data.features.filter(feature => {
            const controlDate = feature.properties.datum_zadnje_kontrole_mm;
            return controlDate >= verificationYearRange[0] && controlDate <= verificationYearRange[1];
        });

        const filteredLayer = new GeoJsonLayer({
            id: 'filtered-by-control-date-mjerna-mjesta-layer',
            data: {
                type: "FeatureCollection",
                features: filteredFeatures
            },
            pickable: true,
            getFillColor: [255, 255, 0, 255],
            getLineColor: [255, 255, 0, 255],
            getLineWidth: 15,
            lineWidthScale: 2,
            lineWidthMinPixels: 2,
            pointRadiusMinPixels: 5,
        });

        setWfsLayers(prevLayers => [
            ...prevLayers.filter(layer => layer.id !== 'filtered-by-control-date-mjerna-mjesta-layer'),
            filteredLayer
        ]);
    }
};

export const filterByExpirationYear = (wfsLayers, sealExpiryYearRange, setWfsLayers) => {
    const mjernaMjestaLayer = wfsLayers.find(layer => layer.id === 'mjerna_mjesta-layer');

    if (mjernaMjestaLayer) {
        const filteredFeatures = mjernaMjestaLayer.props.data.features.filter(feature => {
            const expirationYear = feature.properties.godina_isteka_ziga_brojila;
            return expirationYear >= sealExpiryYearRange[0] && expirationYear <= sealExpiryYearRange[1];
        });

        const filteredLayer = new GeoJsonLayer({
            id: 'filtered-by-expiration-year-mjerna-mjesta-layer',
            data: {
                type: "FeatureCollection",
                features: filteredFeatures
            },
            pickable: true,
            getFillColor: [0, 0, 0, 255],
            getLineColor: [0, 0, 0, 255],
            getLineWidth: 15,
            lineWidthScale: 2,
            lineWidthMinPixels: 2,
            pointRadiusMinPixels: 5,
        });

        setWfsLayers(prevLayers => [
            ...prevLayers.filter(layer => layer.id !== 'filtered-by-expiration-year-mjerna-mjesta-layer'),
            filteredLayer
        ]);
    }
};